// extracted by mini-css-extract-plugin
export default {"logo":"logo___hj0QE","title":"title___qQiLT","error":"error___VJpfw","contactUs":"contactUs___cqqwC","contactMethod":"contactMethod___SAlw4"};